import { GLOBAL_OBJ } from './worldwide.js';
var parsedStackResults;
var lastKeysCount;
var cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */

function getFilenameToDebugIdMap(stackParser) {
  var debugIdMap = GLOBAL_OBJ._sentryDebugIds;

  if (!debugIdMap) {
    return {};
  }

  var debugIdKeys = Object.keys(debugIdMap); // If the count of registered globals hasn't changed since the last call, we
  // can just return the cached result.

  if (cachedFilenameDebugIds && debugIdKeys.length === lastKeysCount) {
    return cachedFilenameDebugIds;
  }

  lastKeysCount = debugIdKeys.length; // Build a map of filename -> debug_id.

  cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey) => {
    if (!parsedStackResults) {
      parsedStackResults = {};
    }

    var result = parsedStackResults[stackKey];

    if (result) {
      acc[result[0]] = result[1];
    } else {
      var parsedStack = stackParser(stackKey);

      for (var i = parsedStack.length - 1; i >= 0; i--) {
        var stackFrame = parsedStack[i];
        var filename = stackFrame === null || stackFrame === void 0 ? void 0 : stackFrame.filename;
        var debugId = debugIdMap[stackKey];

        if (filename && debugId) {
          acc[filename] = debugId;
          parsedStackResults[stackKey] = [filename, debugId];
          break;
        }
      }
    }

    return acc;
  }, {});
  return cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */


function getDebugImagesForResources(stackParser, resource_paths) {
  var filenameDebugIdMap = getFilenameToDebugIdMap(stackParser);

  if (!filenameDebugIdMap) {
    return [];
  }

  var images = [];

  for (var path of resource_paths) {
    if (path && filenameDebugIdMap[path]) {
      images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
      });
    }
  }

  return images;
}

export { getDebugImagesForResources, getFilenameToDebugIdMap };